<template>
  <div>
    <content-loader
      :height="15"
      :width="300"
      :speed="2"
      :animate="true"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      v-for="(content, index) in (1, data.count)"
      :key="index">
      <rect x="0" y="0" rx="3" ry="3" width="300" height="15" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'CLIHeaderTitle',
  components: { ContentLoader },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
